/* eslint-disable react-refresh/only-export-components */
/**
 * Admin Routes
 *
 * Routes under /admin/* — rendered via AdminShell, not client-scoped.
 * Accessible only to users with admin permissions (enforced inside AdminRoutes).
 */

import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";

import { AuthGate } from "@/components/access/AuthGate";

// Admin Routes (uses AdminShell)
const AdminRoutes = lazy(() => import("@/pages/admin/AdminRoutes"));

const PageLoader = () => (
  <div className="flex items-center justify-center p-8">
    <div className="text-gray-600">Loading...</div>
  </div>
);

export function adminRoutes() {
  return (
    <>
      {/* =================================================================== */}
      {/* ADMIN ROUTES - Uses AdminShell (not client-scoped)                 */}
      {/* =================================================================== */}

      <Route
        path="admin/*"
        element={
          <AuthGate>
            <Suspense fallback={<PageLoader />}>
              <AdminRoutes />
            </Suspense>
          </AuthGate>
        }
      />
    </>
  );
}
